import { Button } from "@/components/ui/button";
import { Lock, Sparkles, Check } from "lucide-react";

export function UpgradeGate({ feature = "this tool", onUpgrade }) {
  return (
    <div className="max-w-2xl mx-auto px-4 py-20 text-center" data-testid="upgrade-gate">
      <div className="h-14 w-14 rounded-xl bg-navy flex items-center justify-center mx-auto mb-6">
        <Lock className="h-6 w-6 text-persian-rose" />
      </div>
      <span className="text-xs font-mono uppercase tracking-[0.2em] text-persian-blue font-semibold">Premium feature</span>
      <h2 className="font-serif text-3xl sm:text-4xl font-bold text-navy mt-3">
        Unlock {feature} with OCC Premium
      </h2>
      <p className="text-slate-600 mt-3 leading-relaxed">
        The AI Syllabus Architect, Socratic Tutor, and Essay Lab are part of the full Cognitive
        Capital suite — available to subscribers for just $11.99/month.
      </p>
      <div className="mt-8 rounded-2xl border border-slate-200/80 shadow-sm bg-white p-6 text-left">
        <ul className="space-y-2.5">
          {[
            "AI Syllabus Architect — dated AP/SAT study plans",
            "Socratic AI Tutor — step-by-step economics & math",
            "Essay Lab — rubric-scored AP & SAT critiques",
            "Study reminders, calendar & progress tracking",
          ].map((f) => (
            <li key={f} className="flex items-start gap-2.5 text-sm text-navy">
              <Check className="h-4 w-4 text-persian-blue mt-0.5 shrink-0" /> {f}
            </li>
          ))}
        </ul>
        <Button onClick={onUpgrade} data-testid="upgrade-cta-button"
          className="w-full mt-6 bg-persian-rose hover:bg-persian-rosehover text-white font-semibold">
          <Sparkles className="h-4 w-4 mr-2" /> Subscribe — from $11.99/month
        </Button>
      </div>
    </div>
  );
}
